import _toConsumableArray from "/nfs-data/jenkins-slave/nonlive/workspace/sg_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { StyleSheet } from 'react-native';

// Kept in separate file, to avoid name collision with Symbol element
export function resolve(styleProp, cleanedProps) {
  if (styleProp) {
    return StyleSheet ? [styleProp, cleanedProps] :
    // Compatibility for arrays of styles in plain react web
    styleProp[Symbol.iterator] ? Object.assign.apply(Object, [{}].concat(_toConsumableArray(styleProp), [cleanedProps])) : Object.assign({}, styleProp, cleanedProps);
  } else {
    return cleanedProps;
  }
}